import { request } from "@umijs/max";

export function apiGetNotification(id: string) {
    return request(`https://dhhp.edu.vn/api/notification/${id}`);
}

export async function apiNotificationUnreadCount() {
    return request(`notification/unread-count`);
}

export async function apiNotificationDelete(id: string) {
    return request(`https://dhhp.edu.vn/api/notification/delete/${id}`, {
        method: 'POST'
    });
}

export async function apiUserNotificationMarkAsUnread(id: string) {
    return request(`https://dhhp.edu.vn/api/notification/mark-as-unread/${id}`, {
        method: 'POST'
    });
}